// extracted by extract-css-chunks-webpack-plugin
module.exports = {"interestFormPage":"app-pages-interestform--interestFormPage"};